<template>
	<!-- usePagination开启分页 -->
	<!-- loading绑定引入页面的蒙层加载变量 -->
	<q-container usePagination :loading="loading">
		<!-- 使用具名插槽 #toolbar -->
		<!-- #toolbar可替换成slot="toolbar" #井号只是语法糖 -->
		<template #toolbar>
			<a-row :gutter="8">
				<a-col :span="9">
					<a-button :type="'primary'" @click="createOrEdit()" v-if="isGranted('news_add')">
						<a-icon type="plus" />
						<span>{{ l('Create') }}</span>
					</a-button>
				</a-col>
				<a-col :span="12" :offset="3">
					<a-row :gutter="8">
						<!-- 搜索 -->
						<a-col :sm="24">
							<a-form-item>
								<a-input-search
									style="width: 200px"
									name="filterText"
									:placeholder="l('SearchWithThreeDot')"
									@search="search"
									enterButton
									v-model="filterText"
									v-decorator="['filterText']"
								/>
							</a-form-item>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
		</template>
		<!-- 使用具名插槽slot="table" -->
		<!-- 插槽作用域的变量 slot-scope="scopeParam" -->
		<!-- 通过使用scopeParam.scroll.y 获取组件内部计算y值 -->

		<!-- **************行选择*************** -->
		<!-- customRow需要选择表格时添加属性和同名方法，方法不需要重新，在混入里面 -->
		<!-- 行选择默认单选，多选需要再data重写变量 isMultiple 并赋值true -->
		<template slot="table" slot-scope="scopeParam">
			<a-table
				ref="table"
				size="small"
				:pagination="false"
				:columns="columns"
				:rowKey="(tableDatas) => tableDatas.id"
				:scroll="{ x: 1500, y: scopeParam.scroll.y }"
				:dataSource="tableData"
				:customRow="customRow"
				:rowClassName="rowClassName"
			>
				<!--                    阅读数-->
				<span slot="pv" slot-scope="text, record">
					{{ record.pv ? record.pv : 0 }}
				</span>
				<!--                    有效标识-->
				<span slot="enabledMark" slot-scope="text, record">
					<span class="true" v-if="record.enabledMark">
						已发布
					</span>
					<span class="false" v-else>
						无效
					</span>
				</span>
				<span slot="actions" slot-scope="text, record">
					<a-space>
						<!-- 修改 -->
						<a class="table-edit" @click="createOrEdit(record.id)" v-if="isGranted('news_edit')">
							<a-icon type="edit" />{{ l('Edit') }}</a
						>
						<!-- 删除 -->
						<a-popconfirm
							placement="top"
							:okText="l('Ok')"
							:cancelText="l('Cancel')"
							@confirm="deleteNews(record)"
							v-if="isGranted('news_delete')"
						>
							<template slot="title">
								{{ l('ConfirmDeleteWarningMessage') }}
							</template>
							<a class="table-delete"> <a-icon type="delete" />{{ l('Delete') }}</a>
						</a-popconfirm>
					</a-space>
				</span>
			</a-table>
		</template>
		<!-- 使用具名插槽 #page -->
		<template #page>
			<!-- 分页组件只需复制以下代码 -->
			<!-- 处理逻辑和变量都在 app-component-base混入文件 -->
			<a-pagination
				v-model="pageNumber"
				:total="totalItems"
				showSizeChanger
				size="small"
				:defaultPageSize="request.maxResultCount"
				:pageSizeOptions="pageSizeOptions"
				:showTotal="() => showTotal"
				@change="onPageChange"
				@showSizeChange="showPageSizeChange"
			/>
		</template>
	</q-container>
</template>

<script>
import { AppComponentBase } from '@/shared/component-base';
import { NewsServiceProxy } from '../../../shared/service-proxies';
import CreateEditNews from '../../oa/news/create-edit-news/create-edit-news';
import { ModalHelper } from '@/shared/helpers';
import moment from 'moment';

export default {
	name: 'news',
	mixins: [AppComponentBase],
	components: {
		CreateEditNews,
	},
	data() {
		return {
			// 表格
			columns: [
				{
					title: this.l(''),
					dataIndex: 'id',
					width: 50,
					ellipsis: true,
					align: 'center',
					scopedSlots: { customRender: 'id' },
				},
				{
					title: this.l('FullHead'),
					dataIndex: 'fullHead',
					width: 200,
					ellipsis: true,
					align: 'center',
					scopedSlots: { customRender: 'FullHead' },
				},
				{
					title: this.l('Subtitle'),
					dataIndex: 'subtitle',
					width: 200,
					ellipsis: true,
					align: 'center',
					scopedSlots: { customRender: 'Subtitle' },
				},
				{
					title: this.l('AuthorName'),
					dataIndex: 'authorName',
					sorter: false,
					ellipsis: true,
					align: 'center',
					scopedSlots: { customRender: 'authorName' },
				},
				// {
				//     title: this.l("CompileName"),
				//     dataIndex: "compileName",
				//     sorter: false,
				//     ellipsis:true,
				//     align: "center",
				//     scopedSlots: {customRender: "compileName"}
				// },
				{
					title: this.l('CategoryType'),
					dataIndex: 'category.itemDetailName',
					align: 'center',
					ellipsis: true,
					scopedSlots: { customRender: 'category.itemDetailName' },
				},
				{
					title: this.l('ReleaseTime'),
					dataIndex: 'releaseTime',
					align: 'center',
					ellipsis: true,
					scopedSlots: { customRender: 'releaseTime' },
				},
				{
					title: this.l('PV'),
					dataIndex: 'pv',
					align: 'center',
					ellipsis: true,
					scopedSlots: { customRender: 'pv' },
				},
				{
					title: this.l('EnabledMark'),
					dataIndex: 'enabledMark',
					align: 'center',
					ellipsis: true,
					scopedSlots: { customRender: 'enabledMark' },
				},
				{
					title: this.l('Actions'),
					dataIndex: 'actions',
					fixed: 'right',
					align: 'center',
					scopedSlots: { customRender: 'actions' },
					width: 150,
				},
			],
			tableData: [],
		};
	},
	mounted() {
		this._NewsServiceProxy = new NewsServiceProxy(this.$apiUrl, this.$api);
		this.getData();
	},
	methods: {
		getData() {
			this.loading = true;
			this.selectedRowObj = {};

			this._NewsServiceProxy
				.getPagedByNews(
					this.filterText,
					this.request.sorting,
					this.request.maxResultCount,
					this.request.skipCount
				)
				.finally(() => {
					this.loading = false;
				})
				.then((res) => {
					this.tableData = res.items;
					this.tableData.map((item) => {
						item.checked = false;
						item.releaseTime = item.releaseTime ? moment(item.releaseTime).format('YYYY-MM-DD HH:mm') : ' ';
					});
					this.totalItems = res.totalCount;
					this.totalPages = Math.ceil(res.totalCount / this.request.maxResultCount);

					this.pagerange = [
						(this.pageNumber - 1) * this.request.maxResultCount + 1,
						this.pageNumber * this.request.maxResultCount,
					];
				});
		},
		createOrEdit(record) {
			ModalHelper.create(
				CreateEditNews,
				{ id: record },
				{
					width: '900px',
				}
			).subscribe((res) => {
				if (res) {
					this.getData();
				}
			});
		},
		deleteNews(record) {
			this.loading = true;
			this._NewsServiceProxy
				.delete(record.id)
				.finally(() => {
					this.loading = false;
				})
				.then((res) => {
					this.$notification['success']({
						message: this.l('SuccessfullyDeleted'),
					});
					this.search();
				});
		},
	},
};
</script>

<style>
.pagination {
	margin: 10px auto;
	text-align: right;
}

.true {
	margin: auto;
	width: 50px;
	height: 20px;
	font-weight: bold;
	border-radius: 0.25em;
	padding: 5px;
	font-size: 10px;
	color: white;
	background-color: #5cb85c;
	display: flex;
	align-items: center;
	justify-content: center;
}

.false {
	margin: auto;
	width: 50px;
	height: 20px;
	font-weight: bold;
	border-radius: 0.25em;
	padding: 5px;
	font-size: 10px;
	color: white;
	background-color: #777777;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
